// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"ba2f212d","288":"331a096a","948":"7b7632f0","978":"e260848d"}[chunkId] + ".chunk.css";
};